/**
 * 多站点 IP 自动跳转 (Geo IP Redirect) — Prompt 模式
 * 支持 mode = 'prompt' / 'redirect'
 * 文案：i18n.byTarget[目标国家大写] 优先，回退到 i18n 顶层默认。
 */
(function () {
  'use strict';

  var W = window;
  var D = document;
  var NS = (W.GarveeGeoRedirect = W.GarveeGeoRedirect || {});
  var CFG = NS.config;

  NS.testPrompt = testPrompt;

  if (!CFG || !CFG.enabled) return;

  var SESSION_FLAG = 'garvee_geo_prompted';
  var SKIP_PARAM = CFG.skipParam || 'geo';
  var SKIP_VALUE = 'skip';
  var TIMEOUT_MS = num(CFG.timeout, 1500);
  var EXEMPT = (CFG.exemptCountries || ['CN']).map(upper);
  var SITES = CFG.sites || {};
  var COUNTRY_MAP = CFG.countryMap || {};
  var CURRENT_KEY = (CFG.currentSiteKey || '').toLowerCase();
  var MODE = (CFG.mode || 'prompt').toLowerCase();
  var I18N = CFG.i18n || {};

  function getI18n(targetKey) {
    var base = I18N || {};
    var per = (base.byTarget && base.byTarget[(targetKey || '').toUpperCase()]) || {};
    return {
      message: per.message || base.message || "Switch to your local store for local pricing & shipping?",
      yes: per.yes || base.yes || 'Yes, take me there',
      no: per.no || base.no || 'No, stay here',
      close: per.close || base.close || 'Close'
    };
  }

  try {
    var url = new URL(W.location.href);
    if (url.searchParams.get(SKIP_PARAM) === SKIP_VALUE) {
      setSession(SESSION_FLAG, '1');
      cleanSkipParam(url);
      return;
    }
    if (getSession(SESSION_FLAG)) return;
    if ((CFG.redirectScope || 'home') === 'home') {
      var path = W.location.pathname.replace(/\/+$/, '');
      if (path !== '' && path !== '/' && !/^\/[a-z]{2}(-[a-z]{2})?$/i.test(path)) return;
    }
    detectCountry(TIMEOUT_MS).then(function (country) {
      if (!country) return;
      country = upper(country);
      if (EXEMPT.indexOf(country) !== -1) return;
      var targetKey = (COUNTRY_MAP[country] || '').toLowerCase();
      if (!targetKey || targetKey === CURRENT_KEY) return;
      var site = SITES[targetKey];
      if (!site || !site.url || isCurrentHost(site.host)) return;
      if (MODE === 'redirect') { redirectTo(site.url); return; }
      setSession(SESSION_FLAG, '1');
      showPrompt(currentSiteMeta(), site, targetKey);
    })['catch'](noop);
  } catch (err) { log('error', err); }

  function showPrompt(currentSite, targetSite, targetKey) {
    var existing = D.getElementById('garvee-geo-popup');
    if (existing) existing.parentNode.removeChild(existing);
    var T = getI18n(targetKey);
    var root = D.createElement('div');
    root.id = 'garvee-geo-popup';
    root.className = 'garvee-geo-popup';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-live', 'polite');
    var routeHtml =
      '<div class="garvee-geo-popup__route">' +
      '<div class="garvee-geo-popup__site garvee-geo-popup__site--from">' +
      renderFlag(currentSite.flag) +
      '<span class="garvee-geo-popup__name">' + esc(currentSite.name) + '</span>' +
      '</div>' +
      '<span class="garvee-geo-popup__arrow" aria-hidden="true">→</span>' +
      '<div class="garvee-geo-popup__site garvee-geo-popup__site--to">' +
      renderFlag(targetSite.flag) +
      '<span class="garvee-geo-popup__name">' + esc(targetSite.name) + '</span>' +
      '</div>' +
      '</div>';
    root.innerHTML =
      '<button type="button" class="garvee-geo-popup__close" aria-label="' + esc(T.close) + '">&times;</button>' +
      routeHtml +
      '<p class="garvee-geo-popup__text">' + esc(T.message) + '</p>' +
      '<div class="garvee-geo-popup__actions">' +
      '<button type="button" class="garvee-geo-popup__btn garvee-geo-popup__btn--primary" data-action="yes">' + esc(T.yes) + '</button>' +
      '<button type="button" class="garvee-geo-popup__btn garvee-geo-popup__btn--secondary" data-action="no">' + esc(T.no) + '</button>' +
      '</div>';
    D.body.appendChild(root);
    var route = root.querySelector('.garvee-geo-popup__route');
    if (route) route.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:10px;padding:10px 14px;margin:0 0 10px 0;background:#f6f6f6;border-radius:8px;font-size:13px;font-weight:600;color:#1a1a1a;flex-wrap:wrap;';
    Array.prototype.forEach.call(root.querySelectorAll('.garvee-geo-popup__site'), function (el) { el.style.cssText = 'display:inline-flex;align-items:center;gap:6px;white-space:nowrap;'; });
    Array.prototype.forEach.call(root.querySelectorAll('.garvee-geo-popup__flag'), function (el) {
      if (el.tagName === 'IMG') el.style.cssText = 'width:18px;height:14px;object-fit:cover;border-radius:2px;display:inline-block;';
      else el.style.cssText = 'font-size:18px;line-height:1;display:inline-block;';
    });
    var arrow = root.querySelector('.garvee-geo-popup__arrow');
    if (arrow) arrow.style.cssText = 'font-size:16px;color:#666;font-weight:400;flex-shrink:0;';
    var textEl = root.querySelector('.garvee-geo-popup__text');
    if (textEl) textEl.style.cssText = 'margin:0 0 14px 0;font-size:13px;line-height:1.5;color:#333;text-align:center;';
    var actions = root.querySelector('.garvee-geo-popup__actions');
    if (actions) actions.style.cssText = 'display:flex;gap:8px;flex-wrap:wrap;';
    var closeBtn = root.querySelector('.garvee-geo-popup__close');
    if (closeBtn) closeBtn.style.cssText = 'position:absolute;top:2px;right:4px;width:24px;height:24px;padding:0;background:transparent;border:0;font-size:20px;line-height:1;color:#888;cursor:pointer;z-index:2;';
    var btnYes = root.querySelector('[data-action="yes"]');
    var btnNo = root.querySelector('[data-action="no"]');
    applyBtnBase(btnYes); applyBtnBase(btnNo);
    paintPrimary(btnYes, false); paintSecondary(btnNo, false);
    btnYes.addEventListener('mouseenter', function () { paintPrimary(btnYes, true); });
    btnYes.addEventListener('mouseleave', function () { paintPrimary(btnYes, false); });
    btnNo.addEventListener('mouseenter', function () { paintSecondary(btnNo, true); });
    btnNo.addEventListener('mouseleave', function () { paintSecondary(btnNo, false); });
    btnYes.addEventListener('click', function () {
      close();
      var u = targetSite.url || ('https://' + (targetSite.host || '') + '/');
      var sep = u.indexOf('?') >= 0 ? '&' : '?';
      W.location.href = u + sep + SKIP_PARAM + '=' + SKIP_VALUE;
    });
    btnNo.addEventListener('click', function () { close(); });
    if (closeBtn) closeBtn.addEventListener('click', function () { close(); });
    requestAnimationFrame(function () { root.classList.add('is-visible'); });
    log('prompt shown', currentSite.name, '->', targetSite.name);
    function close() {
      root.classList.remove('is-visible');
      setTimeout(function () { if (root.parentNode) root.parentNode.removeChild(root); }, 220);
    }
  }
  function applyBtnBase(b) {
    var s = b.style;
    s.setProperty('position', 'relative', 'important');
    s.setProperty('z-index', '1', 'important');
    s.setProperty('display', 'inline-block', 'important');
    s.setProperty('flex', '1 1 auto', 'important');
    s.setProperty('min-width', '120px', 'important');
    s.setProperty('padding', '9px 14px', 'important');
    s.setProperty('margin', '0', 'important');
    s.setProperty('border-radius', '8px', 'important');
    s.setProperty('font-size', '13px', 'important');
    s.setProperty('font-weight', '600', 'important');
    s.setProperty('line-height', '1.2', 'important');
    s.setProperty('text-align', 'center', 'important');
    s.setProperty('text-transform', 'none', 'important');
    s.setProperty('letter-spacing', 'normal', 'important');
    s.setProperty('text-shadow', 'none', 'important');
    s.setProperty('box-shadow', 'none', 'important');
    s.setProperty('background-image', 'none', 'important');
    s.setProperty('cursor', 'pointer', 'important');
    s.setProperty('font-family', 'inherit', 'important');
    s.setProperty('appearance', 'none', 'important');
    s.setProperty('-webkit-appearance', 'none', 'important');
    s.setProperty('transition', 'background-color .15s ease, border-color .15s ease, color .15s ease', 'important');
  }
  function paintPrimary(b, hover) {
    var bg = hover ? '#333333' : '#1a1a1a';
    b.style.setProperty('background-color', bg, 'important');
    b.style.setProperty('color', '#ffffff', 'important');
    b.style.setProperty('border', '1px solid ' + bg, 'important');
  }
  function paintSecondary(b, hover) {
    b.style.setProperty('background-color', '#ffffff', 'important');
    b.style.setProperty('color', '#1a1a1a', 'important');
    b.style.setProperty('border', '1px solid ' + (hover ? '#1a1a1a' : '#d0d0d0'), 'important');
  }
  function renderFlag(flag) {
    var v = String(flag || '').trim();
    if (!v) return '';
    if (/^(https?:)?\/\//.test(v) || v.charAt(0) === '/') {
      return '<img class="garvee-geo-popup__flag" src="' + esc(v) + '" alt="" />';
    }
    return '<span class="garvee-geo-popup__flag garvee-geo-popup__flag--emoji">' + esc(v) + '</span>';
  }
  function currentSiteMeta() { return SITES[CURRENT_KEY] || { name: '', flag: '', url: '', host: W.location.host }; }
  function testPrompt(key) {
    var k = (key || '').toLowerCase();
    var site = SITES[k];
    if (!site) { console.warn('[geo-redirect] testPrompt: unknown key', k); return; }
    showPrompt(currentSiteMeta(), site, k);
  }
  function redirectTo(targetUrl) {
    setSession(SESSION_FLAG, '1');
    var u; try { u = new URL(targetUrl, W.location.href); } catch (e) { return; }
    u.searchParams.set(SKIP_PARAM, SKIP_VALUE);
    log('redirect', u.toString());
    W.location.replace(u.toString());
  }
  function detectCountry(timeoutMs) {
    var endpoints = (CFG.endpoints && CFG.endpoints.length) ? CFG.endpoints : [
      { url: 'https://www.cloudflare.com/cdn-cgi/trace', parser: 'cf' },
      { url: 'https://ipapi.co/json/', parser: 'json', field: 'country' },
      { url: 'https://ipwho.is/', parser: 'json', field: 'country_code' }
    ];
    return new Promise(function (resolve) {
      var settled = false;
      var timer = setTimeout(function () { settled = true; resolve(null); }, timeoutMs);
      tryEndpoint(0);
      function done(v) { if (settled) return; settled = true; clearTimeout(timer); resolve(v); }
      function tryEndpoint(i) {
        if (settled) return;
        if (i >= endpoints.length) return done(null);
        var ep = endpoints[i];
        var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        var opts = { credentials: 'omit', cache: 'no-store' };
        if (ctrl) opts.signal = ctrl.signal;
        var perTimer = setTimeout(function () { if (ctrl) ctrl.abort(); }, timeoutMs);
        fetch(ep.url, opts).then(function (r) { return r.text(); }).then(function (text) {
          clearTimeout(perTimer);
          var c = parse(text, ep);
          if (c) return done(c);
          tryEndpoint(i + 1);
        })['catch'](function () { clearTimeout(perTimer); tryEndpoint(i + 1); });
      }
      function parse(text, ep) {
        try {
          if (ep.parser === 'cf') { var m = /(?:^|\n)loc=([A-Z]{2})/.exec(text); return m ? m[1] : null; }
          if (ep.parser === 'json') {
            var j = JSON.parse(text);
            var v = j[ep.field || 'country'] || j.country_code || j.country || null;
            return typeof v === 'string' && v.length === 2 ? v : null;
          }
          var t = (text || '').trim();
          return /^[A-Za-z]{2}$/.test(t) ? t : null;
        } catch (e) { return null; }
      }
    });
  }

  function isCurrentHost(host) { if (!host) return false; return normalizeHost(W.location.host) === normalizeHost(host); }
  function normalizeHost(h) { return String(h || '').toLowerCase().replace(/^https?:\/\//, '').replace(/\/.*$/, '').replace(/^www\./, ''); }
  function cleanSkipParam(url) {
    try {
      url.searchParams['delete'](SKIP_PARAM);
      var clean = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
      if (W.history && W.history.replaceState) W.history.replaceState({}, '', clean);
    } catch (e) { }
  }

  function getSession(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function setSession(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { } }
  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function upper(s) { return String(s || '').toUpperCase(); }
  function num(v, def) { var n = Number(v); return n > 0 ? n : def; }
  function noop() { }
  function esc(s) { return s == null ? '' : String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function log() {
    if (!CFG.debug) return;
    try { var args = Array.prototype.slice.call(arguments); args.unshift('[geo-redirect]'); console.log.apply(console, args); } catch (e) { }
  }
})();